import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=f9a17e66&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=f9a17e66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a17e66",
  null
  
)

export default component.exports